import { useMutation } from '@tanstack/react-query';

import { syncOidcRoles } from '../services/roles.service';

/**
 * Hook to sync OIDC roles after login
 * This mutation can be called after successful authentication
 * to update oidc_role_id in the local roles table
 */
export const useSyncOidcRoles = () => {
  return useMutation({
    mutationFn: syncOidcRoles,
    onError: (error) => {
      console.error('Failed to sync OIDC roles:', error);
    },
  });
};
